<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="30rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-if="helper === true" block color="success" v-on="on">
        <v-icon small left>fa-plus</v-icon>
        Créer
      </v-btn>
      <v-list-item v-else-if="listItem === true" @click="openDialog">
        <v-list-item-title>
          Unité de mesure
        </v-list-item-title>
      </v-list-item>
      <v-btn v-else text color="success" v-on="on">
        <v-icon small left>fa-plus</v-icon>
        Nouvelle Unité
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          v-show="!loading"
          class="mt-3"
          @submit.prevent="addCustomUnit"
        >
          <v-text-field
            class="no-before"
            ref="nameInput"
            filled
            label="Nom de l'unité"
            v-model="name"
            hide-details="auto"
            :rules="[
              v => !!v || 'Un nom est requis',
              v => v !== '' || 'Un nom est requis',
              v => v !== ' ' || 'Un nom est requis'
            ]"
          ></v-text-field>
        </v-form>
        <v-row align="center" no-gutters v-show="loading">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            color="success"
            :disabled="!valid || loading"
            :block="$vuetify.breakpoint.xsOnly"
            :large="$vuetify.breakpoint.xsOnly"
            @click="addCustomUnit"
          >
            <v-icon small left>fa-check</v-icon>
            Ajouter</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "CustomUnitAdder",
  props: {
    helper: {
      type: Boolean,
      default: false
    },
    listItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getOrganisationId"])
  },
  data() {
    return {
      dialog: false,
      name: "",
      loading: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      setTimeout(() => (this.dialog = true), 100);
    },
    async addCustomUnit() {
      try {
        this.loading = true;
        const d = {
          organisation: this.getOrganisationId,
          name: this.name
        };
        await api.postCustomUnit(d);
        this.$emit("update");
        this.dialog = false;
        this.$refs.form.reset();
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        setTimeout(() => this.$refs.nameInput.focus(), 100);
      }
    }
  }
};
</script>

<style></style>
